module.exports = __webpack_public_path__ + "static/img/duom055.ec495ac.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/duom055.png
// module id = 992
// module chunks = 0